import { render, staticRenderFns } from "./group-screens.vue?vue&type=template&id=3620226a"
import script from "./group-screens.vue?vue&type=script&lang=js"
export * from "./group-screens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports